import { Directive, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, Validator } from '@angular/forms';
/**
 * @abstract
 */
export abstract class ComparisonDirective implements Validator, OnChanges {
private ctrl: AbstractControl;
/**
 * @param {?} key
 */
constructor(private key: string) {
  }
/**
 * @param {?} control
 * @return {?}
 */
validate(control: AbstractControl): {[key: string]: any}|null {
    this.ctrl = control;

    return !this.validateCore(control) ? this.createErrorObject() : null;
  }
/**
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: SimpleChanges): void {
    if (this.ctrl) {
      this.ctrl.updateValueAndValidity();
    }
  }
/**
 * @return {?}
 */
private createErrorObject(): {[key: string]: any} {
    const /** @type {?} */ error: {[key: string]: any} = {};

    error[this.key] = true;

    return error;
  }
/**
 * @abstract
 * @param {?} control
 * @return {?}
 */
validateCore(control: AbstractControl) {}
}

function ComparisonDirective_tsickle_Closure_declarations() {
/** @type {?} */
ComparisonDirective.prototype.ctrl;
/** @type {?} */
ComparisonDirective.prototype.key;
}

